:host {
  display: block;
}

.spw-file-upload {
  display: block;
  position: relative;

  &__wrapper {
    &--error {
      border-color: #ff4d4d;
      background-color: #ffe6e6;
    }

    &--dragging {
      background-color: #e0f7fa;
      border-color: #00acc1;
    }
  }

  spw-button {
    display: inline-block;
    margin-bottom: 8px;
  }

  &__errors {
    font-size: 14px;
    color: var(--spw-colors-dark-themes-red-red-500);
    font-weight: 600;
    li {
      margin-top: 16px;
    }
    &--warning {
      color: var(--spw-color-themes-grey-grey-800);
      font-weight: 400;
    }
  }

  &__hints {
    font-size: 14px;
    color: var(--spw-colors-dark-themes-blue-grey-blue-grey-800);
    margin-top: 16px;
  }
}

.spw-file-upload__dropzone {
  cursor: pointer;
  color: #555;
  background: var(--spw-colors-dark-themes-blue-grey-blue-grey-50);
  padding: 20px;
  border-radius: 8px;
  border: 1px dashed #333;
  font-weight: bold;
  text-align: center;

  &:not(.spw-file-upload--disabled):hover {
    outline: 4px solid var(--spw-color-themes-grey-grey-300);
  }

  &:not(.spw-file-upload__wrapper--disabled):focus-visible,
  &:not(.spw-file-upload__wrapper--disabled):active,
  &:not(.spw-file-upload__wrapper--disabled):focus-within {
    outline: 2px solid var(--spw-ds-focus);
  }

  &-link {
    color: var(--spw-ds-primary);
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
    .spw-file-upload__wrapper--disabled & {
      color: inherit;
      text-decoration: none;
    }
  }

  .spw-file-upload__wrapper--disabled & {
    cursor: not-allowed;
    background: var(--spw-color-themes-grey-grey-100);
    color: var(--spw-color-themes-grey-grey-400);
    border-color: var(--spw-color-themes-grey-grey-300);
    outline: none !important;
  }

  .spw-file-upload--is-dragging & {
    background: var(--spw-colors-dark-themes-blue-grey-blue-grey-200);
  }
}

.spw-file-upload__info {
  &-list {
    margin-top: 16px;
    border-top: 1px solid #eee;

    li {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: space-between;
      align-items: center;
      padding: 16px 8px;
      border-bottom: 1px solid #eee;
      color: var(--spw-color-themes-grey-grey-900);
      font-size: 14px;

      @include breakpoint(md) {
        flex-wrap: nowrap;
        gap: 16px;
      }
    }

    &-actions {
      display: flex;
      gap: 8px;
      @include breakpoint(md) {
        gap: 16px;
      }
    }

    &-delete {
      color: inherit;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
